import Vue from "vue";
import Router from "vue-router";
// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router);

/* Layout */
import Layout from "../views/layout/Layout";

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/

//所有权限通用路由表
//如首页和登录页和一些不用权限的公用页面
export const constantRouterMap = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true,
  },
  {
    path: "/error/401",
    component: () => import("@/views/error/401"),
    hidden: true,
  },
  {
    path: "/error/404",
    component: () => import("@/views/error/404"),
    hidden: true,
  },
  {
    path: "",
    component: Layout,
    name: "",
    hidden: false,
    children: [
      {
        path: "/",
        name: "Dashboard",
        meta: { title: "首页", icon: "dashboard", affix: true },
        component: () => import("@/views/dashboard/index"),
      },
    ],
  },
  {
    path: "",
    component: Layout,
    name: "Info",
    hidden: true,
    children: [
      {
        path: "/info",
        component: () => import("@/views/info/index"),
      },
    ],
  },
  {
    path: "/redirect",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/redirect/:path*",
        component: () => import("@/views/redirect/index"),
      },
    ],
  },
];

//实例化vue的时候只挂载constantRouter
export default new Router({
  mode: "history",
  routes: constantRouterMap,
});

//异步挂载的路由
//动态需要根据权限加载的路由表
//meta无permissions字段则不做权限控制
export const asyncRouterMap = [
  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "Operate",
    meta: {
      title: "运营管理",
      permissions: ["admin", "operate"],
      icon: "yy",
    },
    children: [
      {
        path: "/operate/home-banner",
        name: "HomeBanner",
        component: () => import("@/views/operation/home-banner/index"),
        meta: { title: "首页banner管理", permissions: ["admin", "operate"] },
      },

      {
        path: "/operate/discover-banner",
        name: "DiscoverBanner",
        component: () => import("@/views/operation/discover-banner/index"),
        meta: { title: "发现页banner管理", permissions: ["admin", "operate"] },
      },

      {
        path: "/operate/eject",
        name: "Eject",
        component: () => import("@/views/operation/eject/index"),
        meta: { title: "弹窗管理", permissions: ["admin", "operate"] },
      },

      {
        path: "/operate/notification",
        name: "Notification",
        component: () => import("@/views/operation/notification/index"),
        meta: { title: "通知管理", permissions: ["admin", "operate"] },
      },

      {
        path: "/operate/module",
        name: "Module",
        component: () => import("@/views/module/module"),
        meta: { title: "模块管理", permissions: ["admin", "operate"] },
      },

      {
        path: "/operate/news",
        name: "News",
        component: () => import("@/views/news/index"),
        meta: { title: "资讯管理", permissions: ["admin", "operate"] },
      },
      {
        path: "/operate/launch",
        name: "Launch",
        component: () => import("@/views/operation/launch/index"),
        meta: { title: "启动页管理", permissions: ["admin", "operate"] },
      },
      {
        path: "/operate/channel-manager",
        name: "ChannelManager",
        component: () => import("@/views/operation/channel-manager/index"),
        meta: { title: "渠道管理", permissions: ["admin", "operate"] },
      },
    ],
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "Basics",
    meta: { title: "基础管理", permissions: ["admin", "basics"], icon: "tree" },
    children: [
      {
        path: "/basics/about",
        name: "Basics",
        component: () => import("@/views/about/index"),
        meta: { title: "关于我们", permissions: ["admin", "basics"] },
      },
      {
        path: "/basics/help",
        name: "Help",
        component: () => import("@/views/help/index"),
        meta: { title: "常见问题", permissions: ["admin", "basics"] },
      },
      {
        path: "/basics/cooperation",
        name: "Cooperation",
        component: () => import("@/views/cooperation/index"),
        meta: { title: "商务合作", permissions: ["admin", "basics"] },
      },
      {
        path: "/basics/protocol-setting",
        name: "ProtocolSetting",
        component: () => import("@/views/protocol-setting/index"),
        meta: { title: "协议设置", permissions: ["admin", "basics"] },
      },
      {
        path: "/basics/article",
        name: "Article",
        component: () => import("@/views/article/index"),
        meta: { title: "文章管理", permissions: ["admin", "basics"] },
      },
      {
        path: "/basics/evaluation/explain",
        name: "Evaluation",
        component: () => import("@/views/evaluation/explain_index"),
        meta: { title: "指南管理", permissions: ["admin", "basics"] },
      },
      {
        path: "/basics/reviewed-product-categories",
        name: "ReviewedProductCategories",
        component: () => import("@/views/reviewed-product-categories/index"),
        meta: { title: "测评商品分类", permissions: ["admin", "basics"] },
      },
      {
        path: "/basics/assessment-field-management",
        name: "AssessmentFieldManagement",
        component: () => import("@/views/assessment-field-management/index"),
        meta: {
          title: "KOC擅长领域管理",
          permissions: ["admin", "basics"],
        },
      },
      {
        path: "/basics/questionnaire-management",
        name: "QuestionnaireManagement",
        component: () => import("@/views/questionnaire-management/index"),
        meta: {
          title: "问卷模板",
          permissions: ["admin", "basics"],
        },
      },
      {
        path: "/basics/customer-profile",
        name: "CustomerProfile",
        component: () => import("@/views/customer-profile/index"),
        meta: {
          title: "客服资料",
          permissions: ["admin", "basics"],
        },
      },
      {
        path: "/basics/basics-other-setting",
        name: "BasicsOtherSetting",
        component: () => import("@/views/basics-other-setting/index"),
        meta: {
          title: "其它参数设置",
          permissions: ["admin", "basics"],
        },
      },
    ],
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "Point",
    meta: {
      title: "积分管理",
      permissions: ["admin", "point"],
      icon: "jifen",
    },
    children: [
      {
        path: "/point/point-compensation",
        name: "PointCompensation",
        component: () => import("@/views/point/point-compensation/index"),
        meta: { title: "积分补偿", permissions: ["admin", "point"] },
      },
      {
        path: "/point/point-transactionDetail",
        name: "PointTransactionDetail",
        component: () => import("@/views/point/point-transactionDetail/index"),
        meta: { title: "交易明细", permissions: ["admin", "point"] },
      },
      {
        path: "/point/point-setttings",
        name: "PointSetting",
        component: () => import("@/views/point/point-setttings/index"),
        meta: { title: "积分参数设置", permissions: ["admin", "point"] },
      },
    ],
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "User",
    meta: {
      title: "用户管理",
      permissions: ["admin", "user-management", "store"],
      icon: "users",
    },
    children: [
      {
        path: "/users/client",
        name: "Users",
        component: () => import("@/views/user-management/user/index"),
        meta: { title: "用户列表", permissions: ["admin", "user-management"] },
      },
      {
        path: "/users/management",
        name: "MerchantManagement",
        component: () => import("@/views/user-management/merchant/index"),
        meta: { title: "商家管理", permissions: ["admin", "store"] },
      },
    ],
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "Review",
    meta: { title: "测评管理", permissions: ["admin", "review"], icon: "pc" },
    children: [
      {
        path: "/review/review-list",
        name: "ReviewList",
        component: () => import("@/views/review/review-list/index"),
        meta: { title: "测评列表", permissions: ["admin", "review"] },
      },
    ],
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "Order",
    meta: { title: "订单管理", permissions: ["admin", "order"], icon: "dd" },
    children: [
      {
        path: "/order/order-CePing",
        name: "CePing",
        component: () => import("@/views/order/zhongcao/index"),
        meta: { title: "订单列表-测评", permissions: ["admin", "order"] },
      },
      {
        path: "/order/order-questionnaire",
        name: "OrderQuestionnaire",
        component: () => import("@/views/order/questionnaire/index"),
        meta: { title: "订单列表-调查问卷", permissions: ["admin", "order"] },
      },
    ],
  },
  {
    path: "/firstDraft/:id",
    name: "FirstDraft",
    component: () => import("@/views/order/firstDraft/index"),
    hidden: true,
    props: (route) => ({
      ...route.params,
      ...route.query,
    }),
    meta: { title: "查看初稿", permissions: ["admin", "order"] },
  },
  {
    path: "/FirstSubmitDraft/:id",
    name: "FirstSubmitDraft",
    component: () => import("@/views/order/FirstSubmitDraft/index"),
    hidden: true,
    props: (route) => ({
      ...route.params,
      ...route.query,
    }),
    meta: { title: "提交初稿", permissions: ["admin", "order"] },
  },
  {
    path: "/FinalSubmitDraft/:id",
    name: "FinalSubmitDraft",
    component: () => import("@/views/order/FinalSubmitDraft/index"),
    hidden: true,
    props: (route) => ({
      ...route.params,
      ...route.query,
    }),
    meta: { title: "提交终稿", permissions: ["admin", "order"] },
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "Activity",
    meta: {
      title: "活动管理",
      permissions: ["admin", "activity"],
      icon: "hd",
    },
    children: [
      {
        path: "/activity/list",
        name: "EventsList",
        component: () => import("@/views/activity/list/index"),
        meta: { title: "活动列表", permissions: ["admin", "activity"] },
      },
      {
        path: "/registry/:id",
        name: "RegistryList",
        component: () => import("@/views/activity/registry-list/index"),
        hidden: true,
        props: (route) => ({
          ...route.params,
          ...route.query,
        }),
        meta: { title: "报名列表", permissions: ["admin", "activity"] },
      },
    ],
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "Draw",
    meta: { title: "抽奖管理", permissions: ["admin", "draw"], icon: "cj" },
    children: [
      {
        path: "/draw/prize",
        name: "Prize",
        component: () => import("@/views/draw/prize/index"),
        meta: { title: "抽奖商品信息", permissions: ["admin", "draw"] },
      },
      {
        path: "/draw/lucky",
        name: "Lucky",
        component: () => import("@/views/draw/lucky/index"),
        meta: { title: "中奖名单", permissions: ["admin", "draw"] },
      },
      {
        path: "/draw/sweepstakes-record",
        name: "SweepstakesRecord",
        component: () => import("@/views/draw/sweepstakes-record/index"),
        meta: { title: "抽奖记录", permissions: ["admin", "draw"] },
      },
    ],
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "credit-shop",
    meta: {
      title: "积分商城",
      permissions: ["admin", "credit-shop"],
      icon: "shopping",
    },
    children: [
      {
        path: "/credit-shop/product-list",
        name: "ProductList",
        component: () => import("@/views/credit-shop/product-list/index"),
        meta: { title: "商品列表", permissions: ["admin", "credit-shop"] },
      },
      {
        path: "/credit-shop/order-list",
        name: "OrderList",
        component: () => import("@/views/credit-shop/order-list/index"),
        meta: { title: "订单列表", permissions: ["admin", "credit-shop"] },
      },
    ],
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "PayoutManagement",
    meta: {
      title: "提现管理",
      permissions: ["admin", "payout-management"],
      icon: "tx",
    },
    children: [
      {
        path: "/payout-management/payout-requests",
        name: "PayoutRequests",
        component: () =>
          import("@/views/payout-management/PayoutRequests/index"),
        meta: {
          title: "提现列表",
          permissions: ["admin", "payout-management"],
        },
      },
    ],
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "System",
    meta: {
      title: "系统管理",
      permissions: ["admin", "system"],
      icon: "system",
    },
    children: [
      {
        path: "/system/log",
        name: "SystemLog",
        component: () => import("@views/system/system-log/index"),
        meta: { title: "系统日志", permissions: ["admin", "system"] },
      },
      {
        path: "/system/account-management",
        name: "AccountManagement",
        component: () => import("@views/system/account-management/index"),
        meta: { title: "账户管理", permissions: ["admin"] },
      },
    ],
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "Statistic",
    meta: {
      title: "数据统计",
      permissions: ["admin", "statistic"],
      icon: "content",
    },
    children: [
      {
        path: "/statistic/quantity-statistic",
        name: "QuantityStatistics",
        component: () => import("@views/statistic/quantity-statistic/index"),
        meta: { title: "数据统计", permissions: ["admin", "statistic"] },
      },
      {
        path: "/statistic/product-ranking",
        name: "ProductRanking",
        component: () => import("@views/statistic/product-ranking/index"),
        meta: { title: "商品测评排行", permissions: ["admin", "statistic"] },
      },
      {
        path: "/statistic/merchant-ranking",
        name: "MerchantRanking",
        component: () => import("@views/statistic/merchant-ranking/index"),
        meta: { title: "商家被测评排行", permissions: ["admin", "statistic"] },
      },
      {
        path: "/statistic/channel-source",
        name: "ChannelSource",
        component: () => import("@views/statistic/channel-source/index"),
        meta: { title: "渠道来源", permissions: ["admin", "statistic"] },
      },
      {
        path: "/statistic/invite-new",
        name: "InviteNew",
        component: () => import("@views/statistic/invite-new/index"),
        meta: { title: "邀新转化", permissions: ["admin", "statistic"] },
      },
    ],
  },

  // {
  //   path: "",
  //   component: Layout,
  //   alwaysShow: true,
  //   name: "Content",
  //   meta: {
  //     title: "内容管理",
  //     permissions: ["admin", "about"],
  //     icon: "content",
  //   },
  //   children: [
  //     {
  //       path: "/about",
  //       name: "About",
  //       component: () => import("@/views/about/index"),
  //       meta: { title: "关于我们", permissions: ["about"] },
  //     },
  //   ],
  // },

  { path: "*", redirect: "/error/404", hidden: true },
];
